import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import UnpairedPaletteAssignToExistingForm from './UnpairedPaletteAssignToExistingForm';
import * as actions from './store/unpairedPaletteActions';
import * as Yup from "yup";
import { hasPermission, parseURL } from '../../sc-utilities';
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    }
});

const UnpairedPalettesAssignToExisting = props => {
    let { activeCustomerID, onAssignExternalID, translations, permissions, creating } = props;

    const handleSubmit = async formData => {
        let result = await onAssignExternalID({ ...formData, ActiveCustomerID: activeCustomerID, PaletteExternalInfoID: parseURL(window.location.href).PaletteExternalInfoID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = { };
    let formSettings = {
        Validation: { 
            ExternalID: Yup.string().required("Required")
        },
        FormTitle: translations["assign_palette_to"] || "Assign palette to an external data",
        ButtonSubmit: hasPermission(permissions, "unpaired_palette_force_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <>
            {   
                hasPermission(permissions, 'unpaired_palette_assign') ?
                <UnpairedPaletteAssignToExistingForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                    loading={creating}
                /> : null
            }
        </>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        creating: state.palette.unpairedPalettes.creating
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAssignExternalID: data => dispatch(actions.assignExternalID(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(UnpairedPalettesAssignToExisting));